import { motion } from "framer-motion";
import { Bell, Sparkles } from "lucide-react";
import Card from "../components/ui/Card";
import Toggle from "../components/ui/Toggle";
import Pill from "../components/ui/Pill";
import ReminderList from "../components/ui/ReminderList";
import { useAppState } from "../context/AppStateContext";

export default function RemindersPage({ goTo }) {
  const { state, actions } = useAppState();

  return (
    <motion.div initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} className="space-y-4">
      <Card title="Good deeds reminders" icon={Bell}>
        <Toggle
          value={state.reminders.enabled}
          onChange={actions.setRemindersEnabled}
          label="Enable reminders"
          hint="In this MVP, reminders are in-app. You can wire real push notifications later."
        />

        <div className="mt-4">
          <div className="text-sm font-semibold mb-2">Your reminder list</div>
          <ReminderList items={state.reminders.list} onAdd={actions.addReminderItem} onRemove={actions.removeReminderItem} />
        </div>

        <div className="mt-4">
          <div className="text-sm font-semibold mb-2">Suggested prompts</div>
          <div className="flex flex-wrap gap-2">
            {["Make wudu", "Do dhikr for 2 minutes", "Step away from triggers", "Call a friend", "Read 1 page Qur'an"].map((x) => (
              <Pill key={x} onClick={() => actions.addReminderItem(x)}>
                {x}
              </Pill>
            ))}
          </div>
        </div>
      </Card>

      <Card title="In-app nudge" icon={Sparkles}>
        <div className="text-sm text-zinc-700 dark:text-zinc-200">
          When you feel tempted: breathe, change environment, make wudu, and do a quick deed.
        </div>
        <div className="mt-3 grid grid-cols-2 gap-2">
          <button
            onClick={() => goTo("deed")}
            className="rounded-xl bg-white dark:bg-zinc-900/50 ring-1 ring-black/10 dark:ring-white/10 py-3 font-semibold"
          >
            Open daily deed
          </button>
          <button
            onClick={() => goTo("track")}
            className="rounded-xl bg-zinc-900 dark:bg-white text-white dark:text-zinc-900 py-3 font-semibold"
          >
            Check prayers
          </button>
        </div>
      </Card>
    </motion.div>
  );
}
